import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HealthMentorComponent } from './health-mentor.component';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'hm',
		pathMatch: 'full',
	},
	{
		path: 'hm',
		component: HealthMentorComponent,
		data: {
			title: 'Coaching',
		},
	},
	{
		path: 'apt',
		redirectTo: '/scheduling/appointments',
		pathMatch: 'full',
	},
	{
		path: 'hm-quiz',
		redirectTo: 'hm',
		pathMatch: 'full',
	},
	{
		path: 'hm-coaching',
		redirectTo: 'hm',
		pathMatch: 'full',
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class HealthMentorRoutingModule {}
